"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function TriangleExclamation24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.34072 2.17542L0.64005 18.8517C0.41653 19.2801 0.299805 19.7562 0.299805 20.2394C0.299805 21.8963 1.64295 23.2394 3.2998 23.2394H20.7012C21.1844 23.2394 21.6604 23.1227 22.0889 22.8992C23.5578 22.1328 24.1273 20.3207 23.3609 18.8517L14.6602 2.17542C14.3763 1.63126 13.9323 1.18727 13.3882 0.903361C11.9192 0.136956 10.1071 0.706475 9.34072 2.17542ZM12.463 2.67653C12.6444 2.77117 12.7924 2.91916 12.8871 3.10055L21.5877 19.7768C21.8432 20.2665 21.6534 20.8705 21.1637 21.126C21.0209 21.2005 20.8622 21.2394 20.7012 21.2394H3.2998C2.74752 21.2394 2.2998 20.7917 2.2998 20.2394C2.2998 20.0783 2.33871 19.9196 2.41322 19.7768L11.1139 3.10055C11.3511 2.64588 11.8889 2.44971 12.3565 2.62855L12.463 2.67653ZM11.0005 7.23941H13.0005V15.2394H11.0005V7.23941ZM11.0005 17.2394H13.0005V19.2394H11.0005V17.2394Z", fill: "#383F49" }));
}
function TriangleExclamation24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(TriangleExclamation24Svg, Object.assign({}, svgProps)));
}
exports.default = TriangleExclamation24;
//# sourceMappingURL=TriangleExclamation24.js.map